import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=732b7cec&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=732b7cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732b7cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732b7cec')) {
      api.createRecord('732b7cec', component.options)
    } else {
      api.reload('732b7cec', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=732b7cec&scoped=true&", function () {
      api.rerender('732b7cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4SzzCgDbdd4rY/JS/comp/PopupBox.vue"
export default component.exports